import { fetchWrapper, accessLog } from "@/helpers";

const BASE_URL = `${import.meta.env.VITE_API_URL}`;

const fetchTokenConfig = async (token) => {
  // Check for existing access log UUID in sessionStorage
  const existingUuid = accessLog.getAccessLogUuid(token);

  // Build URL with access_log_uuid param if it exists
  const params = new URLSearchParams();
  if (existingUuid) {
    params.append("access_log_uuid", existingUuid);
  }
  const queryString = params.toString();
  const url = `${BASE_URL}/tokens/${token}/config${queryString ? `?${queryString}` : ""}`;

  // Fetch config from server
  const response = await fetchWrapper.get(url);

  // Store the access_log_uuid from response if provided
  if (response && response.access_log_uuid) {
    accessLog.setAccessLogUuid(token, response.access_log_uuid);
  }

  return response;
};

const tokenLogin = async (
  token,
  { turnstileToken = null, prolificParams = null, reviewToken = null } = {},
) => {
  const params = new URLSearchParams();

  // Add turnstile token if provided
  if (turnstileToken) {
    params.append("cf_turnstile_response", turnstileToken);
  }

  if (prolificParams) {
    Object.entries(prolificParams).forEach(([key, value]) => {
      if (value !== undefined && value !== null && value !== "") {
        params.append(key, String(value));
      }
    });
  }

  if (reviewToken) {
    params.append("review_token", reviewToken);
  }

  // Add access log UUID if it exists in sessionStorage
  const existingUuid = accessLog.getAccessLogUuid(token);
  if (existingUuid) {
    params.append("access_log_uuid", existingUuid);
  }

  const queryString = params.toString();
  const url = `${BASE_URL}/tokens/${token}/login${queryString ? `?${queryString}` : ""}`;
  return await fetchWrapper.get(url);
};

const recordTurnstileDiagnostics = async (token, payload = {}) => {
  const existingUuid = accessLog.getAccessLogUuid(token);
  const body = { ...payload };

  if (existingUuid && !body.access_log_uuid) {
    body.access_log_uuid = existingUuid;
  }

  return await fetchWrapper.post(
    `${BASE_URL}/tokens/${token}/turnstile-diagnostics`,
    body,
  );
};

const logout = async () => {
  return await fetchWrapper.get(`${BASE_URL}/logout`).finally(() => {
    localStorage.clear();
    // Clear all access log UUIDs from sessionStorage
    // This ensures logout → re-login counts as a new click/session
    accessLog.clearAllAccessLogUuids();
  });
};

export const authService = {
  fetchTokenConfig,
  tokenLogin,
  recordTurnstileDiagnostics,
  logout,
};
